import appGlobalScript from '/var/www/3eco/wp-content/themes/3ecotheme/component-library/src/global/app.ts';
export const globalScripts = appGlobalScript;
